import React, { useState } from "react";
import { TradingApi, ApiClient } from "./tradingApiSdk/src";

function detectApiBaseUrl() {
  const hostname = window.location.hostname;
  if (hostname.includes("beta")) {
    return "https://beta-api.edge.a1ultra.com";
  } else if (hostname.includes("127.0.0.1")) {
    return "http://127.0.0.1:5000";
  } else {
    return "https://api.edge.a1ultra.com";
  }
}

export default function HelloComponent() {
  const [input, setInput] = useState("");
  const [responseText, setResponseText] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const client = new ApiClient();
      client.basePath = detectApiBaseUrl();
      client.enableCookies = true;
      client.fetchOptions = { credentials: "include" };

      const tradingApi = new TradingApi(client);

      // We assume getHelloResource has a callback or returns a promise. 
      // If it's callback style, wrap it. If it's promise style, do this:
      const result = await new Promise((resolve, reject) => {
        tradingApi.getHelloResource({ text: input }, (err, data, res) => {
          if (err) reject(err);
          else resolve(data);
        });
      });

      // 'result' might be void or an object, depending on your spec. 
      // Possibly the "returnType" is "Object"? 
      // If not, you can parse the lastResponse or do a manual fetch approach.

      if (!result) {
        setResponseText("No data returned. Check console for actual response.");
        return;
      }
      // If your spec says we have { message, username }, let's just show them:
      setResponseText(`Message: ${result.message}, Username: ${result.username}`);

    } catch (err) {
      console.error("Hello error:", err);
      setResponseText("Error calling hello endpoint");
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <label>
          Enter text:
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            style={{ marginRight: "8px" }}
          />
        </label>
        <button type="submit">Send to /hello</button>
      </form>
      <p>{responseText}</p>
    </div>
  );
}